import React, { useEffect, useState } from "react";
import RazorpayCheckout from '../PaymnentGtaeway/RazorpayCheckout'
import moment from "moment";
import Swal from "sweetalert2";
import MasterService from "../Masters/MasterService";
import SubscriptionServices from "../SuperAdmin/SubscriptionPacks/SubscriptionServices";


const PricingPlans = ({handleSubscriptionChange,TenantID,adminUserExits}) => {

  const [plantype,setPlantype] = useState("All") 
  const [plans,setPlans] = useState([]) 

  const handlePlanChange = (value) =>{
      setPlantype(value)
  } 

  useEffect(() => {
    console.log(TenantID)
    if(TenantID){
    let data = {tenantid:TenantID}
    SubscriptionServices.getAllPlansForTenant(data).then((res)=>setPlans(res.data))
    }
  }, [TenantID])
  


  const onSubscribeClick=(enguagment)=>{


      let data = {
          id: TenantID,
          duration:
            enguagment === "SAASMonthly"
              ? moment(new Date())
                  .add("1", "month")
                  .diff(moment(new Date()), "days")
              : enguagment === "SAASQuarterly"
              ? moment(new Date())
                  .add("3", "month")
                  .diff(moment(new Date()), "days")
              : moment(new Date())
                  .add("1", "year")
                  .diff(moment(new Date()), "days"),
          plan:
            enguagment === "SAASMonthly"
              ? moment(new Date())
                  .add("1", "month")
                  .diff(moment(new Date()), "days")
              : enguagment === "SAASQuarterly"
              ? moment(new Date())
                  .add("3", "month")
                  .diff(moment(new Date()), "days")
              : moment(new Date())
                  .add("1", "year")
                  .diff(moment(new Date()), "days"),
        };
      MasterService.PaymentStatusUpdate(data)
          .then(() => {
            Swal.fire({
              title: `Successfully Subscribed`,
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
            handleAddproductsstats()
          })
          .catch((error) =>
            Swal.fire({
              title: `Request failed: ${error.data}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            })
          );
  }

  const getDurationForPlan = (plan) => {
      const type = plan?.enguagmenttype || "SAASMonthly";
      const unit = type.includes("Yearly") ? ["1", "year"] : type.includes("Quarterly") ? ["3", "month"] : ["1", "month"];
      return moment(new Date()).add(unit[0], unit[1]).diff(moment(new Date()), "days");
  };

  const handlePaymentUpdate = (status, plan) =>{
      if(status){
      const duration = getDurationForPlan(plan);
      let data = {
          id: TenantID,
          duration,
          plan: duration
        };
      MasterService.PaymentStatusUpdate(data)
          .then(() => {
              handleAddproductsstats()
          })
          .catch((error) =>
            Swal.fire({
              title: `Request failed: ${error?.data}`,
              text: "Your payment will be refunded in case of any deduction",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            })
          );
      }
  }

const  handleAddproductsstats = () => {
      let data = {
        accounts: true,
        appmaster: true,
        inventory: true,
        purchase: true,
        sales: true,
        production: true,
        assetmanagement: true,
        dashboard:true,
        salestravel:true,
        id: TenantID,
      };
      MasterService.updateTenantProducts(data)
                .then(() => {
                  if(!adminUserExits){
                  MasterService.addAdminUser(TenantID).then(()=>handleSubscriptionChange())
                  }else{
                    handleSubscriptionChange()
                  }
                })
                .catch((e) => {
                  handleSubscriptionChange()
                  Swal.fire({
                    title: "Error occurred, please try again",
                    text: ".",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#152f5f",
                  });
                });
                
    };

  return (
    <div className="tw-py-12 tw-px-4 sm:tw-px-6 lg:tw-px-8 ">
      <div className="tw-max-w-4xl tw-mx-auto tw-text-center">
        <h2 className="tw-text-3xl tw-font-extrabold tw-text-white sm:tw-text-4xl">
          Choose the right plan for you
        </h2>
        <p className="tw-mt-4 tw-text-lg tw-text-gray-400">
          Whether you are a small business or an enterprise, we have got you covered
        </p>
      </div>

      <div className="tw-mt-10 tw-max-w-7xl tw-mx-auto tw-flex tw-grid-cols-1 tw-gap-8 sm:tw-grid-cols-2 lg:tw-grid-cols-2 tw-overflow-x-auto">
        {/* Small Business Plan */}
        {(!plans || plans.length===0) && (
          <div className="tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-lg tw-p-8 tw-flex tw-flex-col">
            <h3 className="tw-text-xl tw-font-semibold tw-text-blue-600">No plans available</h3>
            <p className="tw-mt-2 tw-text-gray-600">No subscription plans found for your country yet, or Razorpay Plan IDs not linked. Contact support.</p>
          </div>
        )}
        {plans && plans.length>0 && plans.map((e,i)=>{
          let benefits = [];
          try { benefits = e.planbenifits ? JSON.parse(e.planbenifits) : []; } catch { benefits = []; }
          const price = e.subscriptionpricies?.[0];
          return (
        <div key={e.id || i} className="tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-lg tw-p-8 tw-flex tw-flex-col">
          <h3 className="tw-text-xl tw-font-semibold tw-text-blue-600">{e.title}</h3>
          <p className="tw-mt-4 tw-text-3xl tw-font-bold tw-text-gray-900">{price ? `${price.currency}${price.price}` : "Custom"} <span className="tw-text-base tw-font-normal">/{e?.enguagmenttype?.replace("SAAS","")}</span></p>
          <p className="tw-mt-2 tw-text-gray-600">{e.description}</p>
          {!price?.planid && <p className="tw-mt-2 tw-text-sm tw-text-red-600">Razorpay Plan not linked yet.</p>}
          <ul className="tw-my-6 tw-space-y-4 tw-flex-grow">
            {benefits.map((b,j)=>
            <li key={j} className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>{b}
            </li>
            )}
            {/* <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Managed Hosting
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Product Warranty
            </li> */}
          </ul>
          <RazorpayCheckout handlePaymentUpdate={(status)=>handlePaymentUpdate(status, e)} plan={e}/>
        </div>)})}

        {/* Enterprise Plan */}
        <div className="tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-lg tw-p-8 tw-flex tw-flex-col">
          <h3 className="tw-text-xl tw-font-semibold tw-text-blue-600">Enterprise</h3>
          <p className="tw-mt-4 tw-text-3xl tw-font-bold tw-text-gray-900">Custom</p>
          <p className="tw-mt-2 tw-text-gray-600">Best for organizations with complex processes</p>
          <ul className="tw-my-6 tw-space-y-4 tw-flex-grow">
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Unlimited Users
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Managed Hosting
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Product Warranty
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Account Manager
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Priority SLA
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Phone Support
            </li>
            <li className="tw-flex tw-items-center tw-text-gray-600">
              <span className="tw-text-blue-600 tw-mr-2">✔️</span>Large DB Support
            </li>
          </ul>
          <button className="tw-mt-auto tw-w-full tw-bg-black tw-text-white tw-py-3 tw-rounded-lg hover:tw-bg-gray-800 tw-transition tw-duration-300 ">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
